import { Directive, TemplateRef, Input } from '@angular/core';

@Directive({ selector: '[mcGridCell]' })
export class GridCellDirective {
    // tslint:disable-next-line:no-input-rename
    @Input('mcGridCell') templateName: string;
    constructor(public templateRef: TemplateRef<any>) { }
}
